<template>
  <div
    class="sidebar"
    :class="expanded ? 'open' : ''"
    @click="updateExpanded(!expanded)"
  >
    <transition name="fade" mode="out-in">
      <div class="text-little" key="inputs" v-if="expanded">
        <div class="d-flex justify-content-start">
          <img
            class="mr-auto"
            src="../assets/logo-white-wide-125.png"
            alt="RetailDeck Chain Logo"
          />
        </div>
        <p class="alt-text my-3">FILTER PRODUCTS</p>
        <div @click.stop>
          <div class="pn-search-wrap">
            <b-form-input
              class="my-2 nm-sm blue"
              size="sm"
              placeholder="Search by PN"
              id="pn-search"
              v-model="pnSearch"
              trim
            ></b-form-input>
            <i class="fas fa-search"></i>
          </div>

          <b-form-group
            class="my-2"
            id="brand-filter-group"
            label="Brands"
            label-for="brand-filter"
          >
            <b-form-select
              id="brand-filter"
              class="nm-sm blue"
              size="sm"
              v-model="brandFilter"
              trim
              :options="[
                { value: null, text: 'All Brands' },
                { value: 'AMN', text: 'Amana' },
                { value: 'CAF', text: 'Cafe' }
              ]"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            class="my-2"
            id="category-filter-group"
            label="Category"
            label-for="category-filter"
          >
            <b-form-select
              id="category-filter"
              class="nm-sm blue"
              size="sm"
              v-model="categoryFilter"
              trim
              :options="[
                { value: null, text: 'Any Category' },
                { value: 'AC', text: 'Air Conditioning' },
                { value: 'RE', text: 'Refrigeration' }
              ]"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            v-if="categoryFilter !== null"
            id="sub-category-filter-group"
            class="my-2"
            label="Sub-Category"
            label-for="sub-category-filter"
          >
            <b-form-select
              id="sub-category-filter"
              class="nm-sm blue"
              size="sm"
              v-model="subCategoryFilter"
              trim
              :options="[
                { value: null, text: 'Any Sub-Category' },
                { value: 'AC', text: 'Side by side' },
                { value: 'RE', text: 'French door' }
              ]"
            ></b-form-select>
          </b-form-group>

          <label for="">Filters</label>
          <b-form-group class="bg-white text-body p-2 nm-sm blue">
            <b-form-checkbox-group
              v-model="selectedFilterOptions"
              :options="filterOptions"
              switches
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
      <div key="collapsed-icons" class="text-center" v-else>
        <img
          class="ml-auto"
          src="../assets/rd_logo_50.png"
          alt="RetailDeck Chain Logo"
        />
        <div class="mt-3"><i class="fas fa-sliders-h"></i></div>
        <div class="mt-3"><i class="fas fa-eye"></i></div>
        <div class="mt-3"><i class="fas fa-sort"></i></div>
        <div class="mt-3"><i class="fas fa-search-plus"></i></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Sidebar',
  data() {
    return {
      brandFilter: null,
      categoryFilter: null,
      subCategoryFilter: null,
      selectedFilterOptions: [],
      filterOptions: [
        { text: 'Only Show In Stock Items', value: 'osisi' },
        { text: 'Only Show Items With Rebates', value: 'osidsi' },
        { text: 'Only Show Plan to Sell Models', value: 'osissi' },
        { text: 'CLR', value: 'osgisi' },
        { text: 'EOM', value: 'osiesi' },
        { text: 'EXPO', value: 'osiwsi' },
        { text: 'Only Show Custom Items', value: 'osisgi' },
        {
          text: 'Only Show Models with Product Video Or Image Features',
          value: 'osixsi'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['expanded']),
    pnSearch: {
      get() {
        return this.$store.state.pnSearch;
      },
      set(val) {
        this.$store.commit('setPnSearch', val);
      }
    }
  },
  methods: {
    ...mapActions(['updateExpanded'])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
::-webkit-scrollbar-thumb:active {
  background: #000000;
}
::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-track:hover {
  background: #666666;
}
::-webkit-scrollbar-track:active {
  background: #333333;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
.sidebar {
  background: linear-gradient(135deg, #0090ff 7%, #009688 72%) repeat;
  height: 100%;
  width: 50px;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 5px 0;
  color: white;
  box-shadow: 3px 0 12px 1px #999;

  img {
    transition: 0.5s;
    transform: scale(0.75);
  }

  .pn-search-wrap {
    position: relative;
    .fa-search {
      color: #aaa;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  &.open {
    width: 250px;
    padding: 5px 15px;
    box-shadow: 3px 0 12px 1px #666;
    img {
      margin-top: 12px;
    }
  }

  h3 {
    padding-right: 12px;
    i:hover {
      cursor: pointer;
      color: #c0e3fd;
    }
  }
}
</style>
